
import { Chain } from "./types/IAddresses";

export const NETWORK_ID = 1;
export const INFURA_ID = "642d3763b1094e0d8627decbf13e70bb";
export const MAIN_ETHERSCAN_API_KEY = "X5HRH5YDH87X812MS9MYH3HD3BZBSHWYN4"
export const BACKEND_URL = "https://api.kaijulegends.io";
// export const BACKEND_URL = "http://localhost:5045";

export const chainInfo: Chain = {
    1: {
        CHAIN:                       "mainnet",
        CHAIN_HEX:                   "0x01",
        CHAIN_NAME:                  "Ethereum Mainnet",
        ETHERSCAN_API:               "https://api.etherscan.io/",
        BLOCK_EXPLORER:              "https://etherscan.io",
        PROVIDER:                    `https://mainnet.infura.io/v3/${INFURA_ID}`
    },
    4: {
        CHAIN:                       "rinkeby",
        CHAIN_HEX:                   "0x04",
        CHAIN_NAME:                  "Rinkeby Testnet",
        ETHERSCAN_API:               "https://api-rinkeby.etherscan.io/",
        BLOCK_EXPLORER:              "https://rinkeby.etherscan.io",
        PROVIDER:                    `https://rinkeby.infura.io/v3/${INFURA_ID}`
    }
}


export const BIG_DECIMAL_18 = 1e18;
export const chain = chainInfo[NETWORK_ID];